/* eslint-disable no-useless-escape */
/* eslint-disable no-console */
/* eslint-disable no-undef */
import jQuery from 'jquery';
import 'jquery-validation';
import { setupPhoneInputEvents } from './phone-input-module';

const SalesForceForm = {
  onReady: () => {
    (function ($) {
      const $salesForceLandingPageForm = $('.salesforce-landing-page-form');
      const $phoneInputs = $salesForceLandingPageForm.find('.mobile');
      const $countryNameAdd = $salesForceLandingPageForm.find('.00N5g00000OZ5f1');

      if ($phoneInputs.length > 0) {
        $phoneInputs.each(function () {
          setupPhoneInputEvents($(this), $phoneInputs, $countryNameAdd);
        });
      }

      $.validator.addMethod(
        'nameValidation',
        function (value, element) {
          // Regular expression pattern to validate the name
          var pattern = /^(?!.*\d)[\p{L}\p{M}'@ ,+\-_]+$/u;
          return this.optional(element) || pattern.test(value);
        },
        'Please enter a valid name without numbers.'
      );
      $.validator.addMethod(
        'customEmail',
        function (value, element) {
          const pattern =
            /^([\w-\.]+@(?!mailinator.com)(?!gmail.com)(?!protonmail.com)(?!cloudmdrive.my.id)(?!icloud.com)(?!gmial.com)(?!gmali.com)(?!yahoo.com)(?!hotmail.com)(?!aol.com)(?!hotmail.co.uk)(?!gamil.com)(?!gmanil.com)(?!gmali.com)(?!hotmail.fr)(?!msn.com)(?!yahoo.fr)(?!wanadoo.fr)(?!orange.fr)(?!comcast.net)(?!yahoo.co.uk)(?!yahoo.com.br)(?!yahoo.co.in)(?!live.com)(?!rediffmail.com)(?!free.fr)(?!gmx.de)(?!web.de)(?!yandex.ru)(?!ymail.com)(?!libero.it)(?!outlook.com)(?!uol.com.br)(?!bol.com.br)(?!mail.ru)(?!cox.net)(?!hotmail.it)(?!sbcglobal.net)(?!sfr.fr)(?!live.fr)(?!verizon.net)(?!live.co.uk)(?!googlemail.com)(?!yahoo.es)(?!ig.com.br)(?!live.nl)(?!bigpond.com)(?!terra.com.br)(?!yahoo.it)(?!neuf.fr)(?!yahoo.de)(?!alice.it)(?!rocketmail.com)(?!att.net)(?!laposte.net)(?!facebook.com)(?!bellsouth.net)(?!yahoo.in)(?!hotmail.es)(?!charter.net)(?!yahoo.ca)(?!yahoo.com.au)(?!rambler.ru)(?!bozzcello.com)(?!bozztirex.us)(?!vivaldigital.com)(?!hotmail.de)(?!tiscali.it)(?!shaw.ca)(?!yahoo.co.jp)(?!sky.com)(?!earthlink.net)(?!optonline.net)(?!freenet.de)(?!t-online.de)(?!aliceadsl.fr)(?!virgilio.it)(?!home.nl)(?!qq.com)(?!telenet.be)(?!me.com)(?!yahoo.com.ar)(?!tiscali.co.uk)(?!yahoo.com.mx)(?!voila.fr)(?!gmx.net)(?!mail.com)(?!planet.nl)(?!tin.it)(?!live.it)(?!ntlworld.com)(?!arcor.de)(?!yahoo.co.id)(?!frontiernet.net)(?!hetnet.nl)(?!live.com.au)(?!yahoo.com.sg)(?!zonnet.nl)(?!club-internet.fr)(?!juno.com)(?!optusnet.com.au)(?!blueyonder.co.uk)(?!bluewin.ch)(?!skynet.be)(?!sympatico.ca)(?!windstream.net)(?!mac.com)(?!centurytel.net)(?!chello.nl)(?!live.ca)(?!aim.com)(?!work.nigga.com)(?!mytruecrimepodcast.com)(?!bigpond.net.au)([\w-]+\.)+[\w-]{2,12})?$/;
          return this.optional(element) || pattern.test(value);
        },
        'Please enter a valid email address.'
      );
      $.validator.addMethod(
        'phoneValidation',
        function (value, element) {
          var pattern = /^[0-9+]{6,15}$/;
          return this.optional(element) || pattern.test(value);
        },
        'Please enter a valid number.'
      );

      $('.form-btn').on('click', function (event) {
        event.preventDefault();

        // Manually trigger form validation
        if ($salesForceLandingPageForm.valid()) {
          // If form is valid, you can proceed with your custom logic or submit the form
          $salesForceLandingPageForm.submit();
        }
      });
      $salesForceLandingPageForm.validate({
        rules: {
          last_name: {
            nameValidation: true,
          },
          email: {
            customEmail: true,
          },
          company: {
            nameValidation: true,
          },
          country: {
            required: true,
          },
          mobile: {
            phoneValidation: true,
          },
          terms: {
            required: true,
          },
        },
        messages: {
          last_name: {
            nameValidation: 'This is a required field. Please enter valid input',
          },
          email: {
            customEmail: 'Please enter a valid business email.',
          },
          company: {
            nameValidation: 'This is a required field. Please enter valid input',
          },
          country: {
            required: 'Please select a country.',
          },
          mobile: {
            phoneValidation: 'Should be a number. Please enter valid input',
          },
          terms: {
            required: 'Please provide your consent to be contacted by the Dotgo team on the submitted details.',
          },
        },
        // Place the error messages in the specific errorDiv for each form
        errorPlacement: function (error, element) {
          // Find the closest errorDiv relative to the element and append the error
          var errorDivId = element.attr('name') + '-error';
          var $errorDiv = element.closest('.sfdc-input-wrapper').find('#' + errorDivId);

          // If the error div is found, append the error; otherwise, append to the default .sfdc-error div
          if ($errorDiv.length) {
            error.appendTo($errorDiv);
          } else {
            error.appendTo(element.closest('.sfdc-input-wrapper').find('.sfdc-error'));
          }
        },
        submitHandler: function submitHandler(form) {
          // Form is valid, perform form submission
          if ($(form).valid()) {
            const formValues = {};
            $salesForceLandingPageForm.find('input, textarea, select').each(function () {
              const $input = $(this);
              const name = $input.attr('name');
              const value = $input.val();

              formValues[name] = value;
            });

            $.ajax({
              url: wpCustomVariables.ajaxUrl,
              type: 'POST',
              data: {
                action: 'process_salesforce_form',
                formValues: formValues,
              },
              success: function success(response, textStatus, jqXHR) {
                if (jqXHR.status === 200) {
                  // const responseData = JSON.parse(response);

                  const $successFormMessageWrapper = $('.success-form-message'); // Perform actions for a successful response
                  $successFormMessageWrapper.show();
                  $salesForceLandingPageForm.hide();
                } else {
                  console.error('Unexpected HTTP status code:', jqXHR.status);
                }
              },
              error: function error(_error) {
                console.error('Error:', _error);
              },
            });
            return false;
          }
        },
      });
    })(jQuery);
  },
};

export default SalesForceForm;
